import { useEffect, useRef, useState } from "react";

const Placeholder = () => (
  <div className="isso-placeholder" aria-hidden="true">
    <div className="isso-placeholder-line wide" />
    <div className="isso-placeholder-line" />
    <div className="isso-placeholder-line short" />
  </div>
);

export default function LazyIssoThread({ identifier }) {
  const containerRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [IssoComp, setIssoComp] = useState(null);

  useEffect(() => {
    if (!shouldLoad || IssoComp) {
      return;
    }

    let cancelled = false;
    import("./IssoThread").then(mod => {
      if (!cancelled) {
        setIssoComp(() => mod.default);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [shouldLoad, IssoComp]);

  useEffect(() => {
    if (shouldLoad) return;

    const node = containerRef.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setShouldLoad(true);
            observer.disconnect();
          }
        });
      },
      { rootMargin: "200px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [shouldLoad]);

  useEffect(() => {
    if (shouldLoad) return;
    const timeout = window.setTimeout(() => setShouldLoad(true), 5000);
    return () => window.clearTimeout(timeout);
  }, [shouldLoad]);

  return (
    <div ref={containerRef} className="isso-wrapper">
      {shouldLoad && IssoComp ? <IssoComp identifier={identifier} /> : <Placeholder />}
    </div>
  );
}
